import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
}

const HeartIcon: React.FC<Props> = ({ fill = "none", stroke = "#008EC6", strokeWidth = "1.5", ...props }) => {
  return (
    <svg
      {...props}
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.4107 17.9677C6.58942 15.858 1 11.0348 1 6.69444C1 3.82563 3.10526 1.5 6 1.5C7.5 1.5 9 2 11 4C13 2 14.5 1.5 16 1.5C18.8947 1.5 21 3.82563 21 6.69444C21 11.0348 15.4106 15.858 12.5893 17.9677C11.6399 18.6776 10.3601 18.6776 9.4107 17.9677Z"
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HeartIcon;